<template>
  <div class="sanitas-survey">
    <slot />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'SanitasSurvey',

  props: {
    language: {
      type: String,
      required: true,
    },
    touchPoint: {
      type: String,
      required: true,
    },
    partnerNumber: {
      type: String,
    },
    surveyName: {
      type: String,
    },
    basketId: {
      type: String,
    },
    contentId: {
      type: String,
    },
    dcTopic: {
      type: String,
    },
    broker: {
      type: String,
    },
    brokerPanelId: {
      type: String,
    },
    uuid: {
      type: String,
    },
  },
  async created() {
    await this.initSurvey()
    this.$emit('survey-initialised')
  },
  methods: {
    ...mapActions(['init']),
    async initSurvey() {
      await this.init({
        language: this.language,
        touchPoint: this.touchPoint,
        ...(this.partnerNumber && { partnerNumber: this.partnerNumber }),
        ...(this.surveyName && { surveyName: this.surveyName }),
        ...(this.basketId && { basketId: this.basketId }),
        ...(this.contentId && { contentId: this.contentId }),
        ...(this.dcTopic && { dcTopic: this.dcTopic }),
        ...(this.broker && { broker: this.broker }),
        ...(this.brokerPanelId && { brokerPanelId: this.brokerPanelId }),
        ...(this.uuid && { uuid: this.uuid }),
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.sanitas-survey {
  height: 100%;
}
</style>
